import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';

import { SharedModule } from "@bt/shared";

import { UsersProfileComponent } from './users-profile.component';
import { dirtyParentQueries } from '@angular/core/src/view/query';
import { DirectiveModule } from '@bt/directives/directive.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    DirectiveModule,
    FontAwesomeModule
  ],
  declarations: [
    UsersProfileComponent
  ],
})
export class UsersProfileModule { }


// WEBPACK FOOTER //
// ./src/app/users-profile/users-profile.module.ts